import { Box, Typography, makeStyles } from '@material-ui/core';
import { CONTESTANT_COLORS } from './streamPalette';

const useStyles = makeStyles(theme => ({
    frame: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(4, 6)
    },
    body: {
        flexGrow: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    }
}));

// Every slide of the statistics run is laid out the same: a heading that says
// what is being compared, then the comparison itself.
function SlideFrame(props) {
    const classes = useStyles();
    return (
        <div className={classes.frame}>
            <Box mb={3}>
                <Box display='flex' alignItems='baseline' style={{ gap: 16 }}>
                    <Typography variant='h4' color='textSecondary'> {props.eyebrow} </Typography>
                    {props.matchLabel &&
                        <Typography variant='h4' color='textSecondary'> · {props.matchLabel} </Typography>
                    }
                </Box>
                <Typography variant='h3'> {props.title} </Typography>
            </Box>
            <div className={classes.body}>
                {props.children}
            </div>
        </div>
    );
}

// The name of a contestant over their half of a slide, in their colour. A slide
// whose halves are mostly the contestant's own numbers can set the name larger.
function ContestantHeading(props) {
    return (
        <Typography
            variant={props.variant ?? 'h5'}
            align={props.align ?? 'center'}
            style={{ color: CONTESTANT_COLORS[props.contestant], marginBottom: 12 }}
            noWrap
        >
            {props.name}
        </Typography>
    );
}

export { SlideFrame as default, ContestantHeading };
